import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../../../../App.css';
import MultiTeamInitialisation from '../Datatables/ColumnDefinitions/MultiTeamInitialisation';
import { withClsCompTracking } from '../../../../Telemetry/telemetry.service';

const MultiTeamUpdateView = props => {
	const { multiTeamData, templateData, multiTeamDataChange } = props;
	return (
		<div>
			<BootstrapTable
				classes={'table table-primary table-striped table-sm table-responsive-md smallTableHeight'}
				bootstrap4
				striped
				condensed
				hover
				size="sm"
				keyField="id"
				data={multiTeamData}
				columns={MultiTeamInitialisation(templateData)}
				cellEdit={cellEditFactory({
					mode: 'click',
					blurToSave: true,
					autoSelectText: true,
					timeToCloseMessage: 10000,
					afterSaveCell: (oldValue, newValue, row, column) => multiTeamDataChange()
				})}
			/>
		</div>
	);
};

export default withClsCompTracking('MultiTeam Update Table')(MultiTeamUpdateView);
